const API_BASE = process.env.REACT_APP_API_BASE_URL || "";

async function parseJsonSafe(res) {
  return res.json().catch(() => ({}));
}

function buildAuthHeaders(token, extra = {}) {
  return {
    Authorization: `Bearer ${token}`,
    ...extra,
  };
}

export async function getFornitoreCalendarEvents(token, { from, to } = {}) {
  const qs = new URLSearchParams();
  if (from) qs.set("from", from);
  if (to) qs.set("to", to);

  const res = await fetch(`${API_BASE}/api/fornitore/calendar?${qs.toString()}`, {
    headers: buildAuthHeaders(token),
  });

  const data = await parseJsonSafe(res);

  if (!res.ok) {
    throw new Error(data?.error || "Errore caricamento calendario fornitore");
  }

  return data;
}
